// IMPORT PACKAGE REFERENCES
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

//COMPONENT

class TypeSelectionBar extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            types: [],
            selected: '',
        };

        this.selected = this.selected.bind(this);
    }

    componentDidMount(){
        this.setState({types: this.props.types});
    }

    componentDidUpdate(prevProps){
        if(this.props.types != prevProps.types) {
            this.setState({types: this.props.types});
        }
    }

    selected(event){
        this.props.typeSelected(event);
    }

    render() {
        return (
            <div>
                <div className="type-selection-bar">
                    {this.state.types.map((type) => {
                        return (<div key={type} className={'type-option noselect ' + (type == this.props.selected ? 'selected-type' : 'unselected-type')} onClick={() => this.selected(type)} value={type}>{type}</div>);
                    } )}
                </div>
            </div>
        );
    }
}

TypeSelectionBar.propTypes = {
    types: PropTypes.array.isRequired,
    selected: PropTypes.string,
    typeSelected: PropTypes.func.isRequired
};

const hoc = withRouter(TypeSelectionBar);

// EXPORT COMPONENT
export { hoc as TypeSelectionBar };


// WEBPACK FOOTER //
// ./src/components/containers/TypeSelectionBar.js